import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-dark text-white/80 border-t border-white/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        
        {/* TOP GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Col 1: Brand & Organization */}
          <div className="lg:col-span-1">
            
            {/* FIX: Wrapped in a white pill/box so the logo is perfectly visible without color distortion */}
            <div className="bg-white inline-block p-3 rounded-xl mb-6 shadow-lg">
              <img 
                src="/gris-2027.png" 
                alt="GRIS Summit" 
                className="h-14 object-contain" 
                onError={(e) => { e.target.src = '/gris-2026.png'; }} // Fallback if 2027 image isn't available yet
              />
            </div>
            
            <p className="text-sm leading-relaxed mb-6 font-medium">
              Global Road Infratech Summit & Expo. Transforming Road Infrastructure for a Safer, Smarter and Sustainable India.
            </p>
            <p className="text-sm font-bold text-white">
              Organised by <br/>
              <span className="text-accent block mt-1">International Road Federation – India Chapter</span>
            </p>
          </div>

          {/* Col 2: Quick Links */}
          <div>
            {/* ACCESSIBILITY FIX: Changed h4 -> h2 for correct heading sequence */}
            <h2 className="text-white font-bold uppercase tracking-widest text-xs mb-6 border-b border-white/10 pb-3">
              Quick Links
            </h2>
            <ul className="space-y-4 text-sm font-medium">
              <li><Link to="/about" className="hover:text-accent transition-colors flex items-center gap-2"><span className="text-accent">&rarr;</span> About GRIS</Link></li>
              <li><Link to="/schedule" className="hover:text-accent transition-colors flex items-center gap-2"><span className="text-accent">&rarr;</span> Program & Agenda</Link></li>
              <li><Link to="/exhibition" className="hover:text-accent transition-colors flex items-center gap-2"><span className="text-accent">&rarr;</span> Exhibition Floor</Link></li>
              <li><Link to="/sponsors" className="hover:text-accent transition-colors flex items-center gap-2"><span className="text-accent">&rarr;</span> Sponsorships</Link></li>
              <li><Link to="/contact" className="hover:text-accent transition-colors flex items-center gap-2"><span className="text-accent">&rarr;</span> Contact Secretariat</Link></li>
            </ul>
          </div>

          {/* Col 3: Contact Details */}
          <div className="lg:col-span-2">
            {/* ACCESSIBILITY FIX: Changed h4 -> h2 for correct heading sequence */}
            <h2 className="text-white font-bold uppercase tracking-widest text-xs mb-6 border-b border-white/10 pb-3">
              Contact Information
            </h2>
            <ul className="space-y-5 text-sm font-medium">
              <li className="flex items-start gap-4">
                {/* ACCESSIBILITY FIX: Added aria-hidden to icon SVG */}
                <div className="bg-white/5 p-2 rounded-lg text-accent shrink-0">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                  </svg>
                </div>
                <span className="mt-1 leading-relaxed">
                  T-95A, CL House, 4th Floor, <br/>
                  Yusuf Sarai Commercial Centre, New Delhi-110049
                </span>
              </li>
              <li className="flex items-center gap-4">
                {/* ACCESSIBILITY FIX: Added aria-hidden to icon SVG */}
                <div className="bg-white/5 p-2 rounded-lg text-accent shrink-0">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                  </svg>
                </div>
                <span>
                  +91-11-4019 7827 <br/> 
                  <span className="text-accent font-black">+91 92059 94744</span>
                </span>
              </li>
              <li className="flex items-center gap-4">
                {/* ACCESSIBILITY FIX: Added aria-hidden to icon SVG */}
                <div className="bg-white/5 p-2 rounded-lg text-accent shrink-0">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                  </svg>
                </div>
                {/* ACCESSIBILITY FIX: Added an aria-label to the email link */}
                <a href="mailto:gris2027@irf.org.in" aria-label="Send email to secretariat" className="hover:text-white transition-colors">gris2027@irf.org.in</a>
              </li>
            </ul>
          </div>
        </div>

        {/* BOTTOM LEGAL BAR */}
        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-white/10 text-xs text-white/50 gap-6">
          
          {/* Copyright & Legal Links */}
          <div className="flex flex-col md:flex-row items-center gap-3 md:gap-8 text-center md:text-left">
            <p>© {new Date().getFullYear()} GRIS. All Rights Reserved.</p>
            <div className="flex gap-4">
              <Link to="/terms-conditions" className="hover:text-white transition-colors">Terms & Conditions</Link>
              <span className="text-white/20">|</span>
              <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
            </div>
          </div>
          
          {/* Developer Credit */}
          <p className="uppercase tracking-widest">
            Developed by <a href="https://kopinfotech.com" target="_blank" rel="noreferrer" aria-label="Visit KOP Infotech developer website" className="text-accent hover:text-white font-black transition-colors ml-1">KOP Infotech</a>
          </p>
        </div>
        
      </div>
    </footer>
  );
}